<template>
  <v-card class="ma-0" :maxHeight="height - 24" :minHeight="minHeight">
    <v-card-title class="secondary white--text py-0" @click="$refs.table.refresh()">
      <slot name="title">
        {{ title }}
      </slot>
      <v-spacer />
    </v-card-title>
    <v-divider />
    <v-card-text class="mt-0 pa-1 pt-0">
      <v-lazy
        v-model="isActive"
        :options="{
          threshold: 0.5,
        }"
        min-height="200"
        transition="fade-transition"
      >
        <div v-if="loading" class="loading-block">
          <div class="loader"></div>
        </div>
        <div v-else>
          <v-card-text :style="`height: ${height + ($vuetify.breakpoint.smAndDown ? -60 : -38)}px; overflow: auto`" class="pa-0">
            <a-table-f-api
              v-if="type == 'get'"
              ref="table"
              :api="url"
              :model="model"
              :useQuery="true"
              :defaults="{
                sort: { key: 'id', order: 'DESC' },
                filters: filter,
                paramName: 'documentParent',
              }"
              @click="clickRow"
            />
            <a-table-f-api-post
              v-if="type == 'apiPost'"
              ref="table"
              :apiPost="{ api: url, params: paramsApi }"
              :limit="50"
              :model="model"
              :searchable="false"
              :useQuery="false"
              :defaults="{
                sort: { key: 'id', order: 'DESC' },
                filters: filter,
                paramName: 'documentParent',
              }"
              @click="clickRow"
            />
          </v-card-text>
        </div>
      </v-lazy>
    </v-card-text>
  </v-card>
</template>

<script>
import { popupMenu } from "@/components/mixings";
export default {
  mixins: [popupMenu],
  components: {
    Widget: () => import("./widgets/apiTable"),
    reportDialog: () => import("./../dialogs/objectReportDialog"),
  },
  props: {
    height: { type: Number, default: 0 },
    blockName: { type: String, default: "" },
    config: { type: Object, default: () => {} },
    data: Array,
  },
  data() {
    return {
      isActive: 0,
      contentHeight: 10,
      hideViewed: false,
      showConfig: false,
      type: null,
      url: null,
      paramsApi: null,
      loading: false,
    };
  },
  created() {
    this.init(this.config);
  },
  computed: {
    filter() {
      return this.config?.filter || {};
    },
    title() {
      return this.config?.title || "";
    },
    model() {
      const m = this.config.model;
      let model;
      let fields = (this.config?.docFields || "").split(",") || [];
      if (typeof m == "string") {
        model = JSON.parse(JSON.stringify(this.$store.getters["config/get"].models[m]));
        model = this.getModelList(model, this.config?.modelListName || "list");
        model = model.filter(el => {
          return fields.includes(el.name);
        });
        model.forEach(m => {
          m.hidden = false;
        });
      }
      if (typeof m == "object" && !Array.isArray(m)) {
        model = JSON.parse(JSON.stringify(m));
        model = this.getModelList(model, "list");
      }
      if (typeof m == "object" && Array.isArray(m)) {
        model = JSON.parse(JSON.stringify(m));
      }

      return model;
    },

    minHeight() {
      let h = this.height;
      if (this.$vuetify.breakpoint.name == "xs" && this.data.length == 0) {
        h = 0;
      }
      return h;
    },
  },
  watch: {
    showReportDialog(v) {
      if (!v) {
        this.itemShowClose();
      }
    },
  },
  methods: {
    init(opts) {
      const type = this.getType();

      if (type == "apiPost") {
        this.url = opts.apiPost.api;
        this.paramsApi = opts.apiPost.params || {};
      }
      this.type = type;
    },
    getType() {
      if (typeof this.config.apiPost) return "apiPost";
      if (typeof this.config.api === "string") return "get";

      return "";
    },
    clickRow(e) {
      if (e.field?.isMenu) {
        this.showPopupMenu(e.field.name, e.row, e.event, e);
        return;
      }
      this.idReport = e.row.id;
      this.showReportDialog = true;
    },
  },
};
</script>
